import TripCarouselContent from "./TripCarouselContent"

export default  TripCarouselContent;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/TripPanel/TripPanelTable/TripCarouselContent/index.js